// extracted by mini-css-extract-plugin
module.exports = {"iconWrap":"style_iconWrap__yzkxw"};